import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { Message } from 'element-ui';
import _ from 'lodash';
const getDictList = async () => {
    if (!dictData.saleStages) {
        const dictRes = await getDictDataApi({
            dictCodes: 'NEOCRM_SALE_STAGE_WIN'
        });
        dictData.saleStages = _.keys(dictRes.data.NEOCRM_SALE_STAGE_WIN);
    }
};
const dictData = {
    saleStages: ''
};
export const tableConfig = {
    selection: true,
    height: 325,
    columnsReadonly: [ // 只读表格配置
        {
            label: '商机号',
            prop: 'opportunityCode',
            width: 150
        },
        {
            label: '商机名称',
            prop: 'opportunityName'
        },
        {
            label: '实际中标规模(万)',
            prop: 'totalScale'
        },
        {
            label: '目前规模(万)',
            prop: 'businessScale'
        },
        {
            label: '签单规模(万)',
            prop: 'cdExpectBiddingSize'
        },
        {
            label: '关联项目号',
            prop: 'projectCode'
        },
        {
            label: '分公司',
            prop: 'companyName',
            type: '',
            rule: [
                { required: true, message: '分公司不能为空', trigger: 'blur' }
            ],
            name: '添加分公司',
            value: 'companyName',
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称' }
            ],
            highlightCurrentRow: true,
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            mustFill: true,
            hideTooltip: true,
            width: 200
        },
        {
            label: '服务平台',
            prop: 'siteNames',
            width: 400
        },
        {
            label: '是否纯仓',
            prop: 'isPureWarehouse',
            // type: 'select',
            type: 'custom',
            width: 105,
            optionsKey: 'SYS_CRM_YES_NO'
        },
        {
            label: '仓库类型',
            prop: 'warehouseType',
            type: 'select',
            optionsKey: 'NEOCRM_WH_TYPE',
            width: 100
        },
        {
            label: '合同账期(天)',
            prop: 'contractAccountOf'
        },

        {
            label: '实际中标采购毛利率(%)',
            prop: 'grossMarginPlan'
        },
        {
            label: '运作押金(万)',
            prop: 'deposit'
        },
        {
            label: '结算方式',
            prop: 'settlementMode',
            type: 'select',
            optionsKey: 'SYS_SETTLEMENT'
        },
        {
            label: '承兑占比(%)',
            prop: 'acceptanceRate',
            width: 100
        },
        {
            label: '承兑期限(天)',
            prop: 'acceptanceDays',
            width: 100
        }
    ],
    columnsGroupReadonly: [
        {
            label: '分公司',
            prop: 'companyName',
            width: 180
        },
        {
            label: '服务平台',
            prop: 'siteNames'
            // width: 500
        },
        {
            label: '是否纯仓',
            prop: 'isPureWarehouse',
            // type: 'select',
            type: 'custom',
            width: 105,
            optionsKey: 'SYS_CRM_YES_NO'
        }
    ],
    columns: [ // 新增合同时编辑表格配置
        {
            label: '商机号',
            prop: 'opportunityCode',
            width: 130
        },
        {
            label: '商机名称',
            prop: 'opportunityName',
            width: 130
        },
        {
            label: '实际中标规模(万)',
            prop: 'totalScale',
            width: 120
        },
        {
            label: '目前规模(万)',
            prop: 'businessScale',
            width: 100
        },
        {
            label: '签单规模(万)',
            prop: 'cdExpectBiddingSize',
            width: 100
        },
        {
            label: '分公司',
            prop: 'companyName',
            type: 'advance',
            rule: [
                { required: true, message: '分公司不能为空', trigger: 'blur' }
            ],
            name: '添加分公司',
            value: 'companyName',
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称' }
            ],
            highlightCurrentRow: true,
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
            mustFill: true,
            hideTooltip: true,
            width: 200
        },
        {
            label: '服务平台',
            type: 'slot',
            prop: 'site',
            width: 450,
            value: 'site',
            slot: true,
            editSlot: true,
            mustFill: false,
            disabled: false,
            placeholder: '',
            // siteAdvanceParams: {
            name: '服务平台',
            advanceLabel: '维护服务平台',
            advanceConfig: [
                { 'prop': 'siteNameCn', 'value': '服务平台名称' },
                { 'prop': 'siteCode', 'value': '服务平台编码' }
            ],
            tableConfig: [
                { 'prop': 'siteCode', 'value': '服务平台编码' },
                { 'displayName': 'siteNameCn', 'prop': 'siteNameCn', 'value': '服务平台名称' }
            ],
            prefix: '/api-mdm',
            multiple: true, // 多选
            /* eslint-disable no-magic-numbers */
            pageSizes: [50, 100, 250, 500, 1000],
            advanceUrl: `/esCompany/popSite`,
            cbParams: ['siteCode', 'siteNameCn#siteName'],
            advanceCascade: 'companyCode#companyCode',
            hideTooltip: true
            // }
        },
        {
            label: '是否纯仓',
            prop: 'isPureWarehouse',
            type: 'select',
            mustFill: false,
            optionsKey: 'SYS_CRM_YES_NO',
            width: 105
        },
        {
            label: '仓库类型',
            prop: 'warehouseType',
            type: 'select',
            optionsKey: 'NEOCRM_WH_TYPE',
            width: 100
        }
    ],
    companyAdvanceParams: {
        advanceLabel: '批量添加分公司',
        advanceConfig: [
            { 'prop': 'companyName', 'value': '分公司名称' },
            { 'prop': 'companyCode', 'value': '分公司编码' }
        ],
        tableConfig: [
            { 'prop': 'companyCode', 'value': '分公司编码' },
            { 'displayName': 'companyNameCn', 'prop': 'companyNameCn', 'value': '分公司名称' }
        ],
        // noMinNumLimit: true, // 不限制是否已选数据
        multiple: true, // 多选
        /* eslint-disable no-magic-numbers */
        pageSizes: [50, 100, 250, 500, 1000],
        prefix: '/api-lcrm',
        method: 'post',
        initToggletProp: 'companyCode', // 重新更新toggleProp的当前数据
        advanceUrl: `/contract/company/base/page`,
        cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
        hideTooltip: true
    },
    siteAdvanceParams: { // 单条分公司添加服务平台
        advanceLabel: '维护服务平台',
        advanceConfig: [
            { 'prop': 'siteName', 'value': '服务平台名称' },
            { 'prop': 'siteCode', 'value': '服务平台编码' }
        ],
        tableConfig: [
            { 'prop': 'siteCode', 'value': '服务平台编码' },
            { 'displayName': 'siteNameCn', 'prop': 'siteNameCn', 'value': '服务平台名称' }
        ],
        method: 'post',
        prefix: '/api-lcrm',
        multiple: true, // 多选
        noMinNumLimit: true, // 不限制是否已选数据
        /* eslint-disable no-magic-numbers */
        pageSizes: [50, 100, 250, 500, 1000],
        initToggletProp: 'siteCode', // 重新更新toggleProp的当前数据
        advanceUrl: `/querySiteByCompanyCodes`,
        cbParams: ['siteCode', 'siteNameCn#siteName', 'companyCode', 'companyNameCn#companyName'],
        advanceCascade: 'companyCode#companyCode',
        hideTooltip: true
    },
    siteAdvancePrivilegeParams: { // 批量添加服务平台
        advanceLabel: '批量维护服务平台',
        advanceConfig: [
            { 'prop': 'siteName', 'value': '服务平台名称' },
            { 'prop': 'siteCode', 'value': '服务平台编码' },
            { 'prop': 'companyCode', 'value': '分公司编码' },
            { 'prop': 'companyName', 'value': '分公司名称' }
        ],
        tableConfig: [
            { 'prop': 'siteCode', 'value': '服务平台编码' },
            { 'displayName': 'siteNameCn', 'prop': 'siteNameCn', 'value': '服务平台名称' },
            { 'prop': 'companyCode', 'value': '分公司编码' },
            { 'prop': 'companyNameCn', 'value': '分公司名称' }
        ],
        /* eslint-disable no-magic-numbers */
        pageSizes: [50, 100, 250, 500, 1000],
        multiple: true, // 多选
        noMinNumLimit: true,
        initToggletProp: 'siteCode', // 重新更新toggleProp的当前数据
        method: 'post',
        prefix: '/api-lcrm',
        advanceUrl: `/querySiteByCompanyCodes`,
        cbParams: ['siteCode', 'siteNameCn', 'companyCode', 'companyNameCn'],
        advanceCascade: 'companyCode#companyCode',
        hideTooltip: true
    },
    opportunityAdvance: {
        name: '商机',
        value: 'opportunityCode',
        advanceLabel: '选择商机',
        advanceConfig: [
            { prop: 'opportunityCode', value: '商机编码' },
            { prop: 'opportunityName', value: '商机名称' }
        ],
        tableConfig: [
            {
                value: '商机编码',
                prop: 'opportunityCode',
                width: 130
            },
            {
                value: '商机名称',
                prop: 'opportunityName',
                width: 130
            },
            {
                value: '项目编码',
                prop: 'projectCode',
                width: 160
            },
            {
                value: '分公司',
                prop: 'companyName',
                width: 140
            },
            {
                value: '客户名称',
                prop: 'opportunityCustomerName',
                width: 130
            },
            {
                value: '实际中标规模(万)',
                prop: 'totalScale',
                width: 120
            },
            {
                value: '目前规模(万)',
                prop: 'businessScale',
                width: 100
            },
            {
                value: '签单规模(万)',
                prop: 'cdExpectBiddingSize',
                width: 100
            },
            {
                value: '销售阶段',
                prop: 'saleStage',
                type: 'select',
                optionsKey: 'NEOCRM_SALE_STAGE'
            },
            {
                value: '输单阶段',
                prop: 'lostStage',
                type: 'select',
                optionsKey: 'NEOCRM_SALE_STAGE'
            },
            {
                value: '报签确认',
                prop: 'isSign',
                type: 'select',
                optionsKey: 'NEOCRM_YES_NO'
            },
            {
                value: '中标日期',
                prop: 'winningDate',
                width: 160
            },
            {
                value: '仓库类型',
                prop: 'warehouseType',
                type: 'select',
                optionsKey: 'NEOCRM_WH_TYPE',
                width: 80
            }
        ],
        method: 'post',
        prefix: '/api-lcrm',
        advanceUrl: '/opportunity/info/page',
        cbParams: ['opportunityCode', 'opportunityName'],
        advanceCascade: 'companyCode#companyCode'
    },
    opportunityMuiAdvance: {
        label: '选取项目/商机',
        name: '选取项目/商机',
        prop: 'projectCode',
        value: 'projectCodes',
        labelWidth: '150px',
        dialogWidth: '1200px',
        selection: true,
        type: 'custom',
        focusShowDialog: true,
        visible: true,
        multiple: true,
        border: true,
        disabledDbClick: true,
        firstNoFetch: false,
        rule: [
            { required: false, message: '项目编码不能为空', trigger: ['change', 'blur'] }
        ],
        advanceConfig: [
            { prop: 'projectCode', value: '项目编码' },
            { prop: 'opportunityCode', value: '商机编码' },
            { prop: 'opportunityName', value: '商机名称' },
            { prop: 'opportunityCustomerName', value: '客户' }
        ],
        tableConfig: [
            { prop: 'opportunityCode', value: '商机编码' },
            { prop: 'opportunityName', value: '商机名称' },
            { prop: 'projectCode', value: '项目编码' },
            { prop: 'companyName', value: '分公司' },
            { prop: 'businessCenterName', value: '经营中心' },
            { prop: 'opportunityCustomerName', value: '客户名称' },
            {
                value: '实际中标规模(万)',
                prop: 'totalScale'
            },
            {
                value: '目前规模(万)',
                prop: 'businessScale'
            },
            {
                value: '签单规模(万)',
                prop: 'cdExpectBiddingSize'
            },
            {
                value: '销售阶段',
                prop: 'saleStage',
                type: 'select',
                optionsKey: 'NEOCRM_SALE_STAGE'
            },
            {
                value: '输单阶段',
                prop: 'lostStage',
                type: 'select',
                optionsKey: 'NEOCRM_SALE_STAGE'
            },
            {
                value: '报签确认',
                prop: 'isSign',
                type: 'select',
                optionsKey: 'NEOCRM_YES_NO'
            },
            {
                value: '中标日期',
                prop: 'winningDate',
                width: 160
            },
            {
                value: '仓库类型',
                prop: 'warehouseType',
                type: 'select',
                optionsKey: 'NEOCRM_WH_TYPE'
            },
            {
                value: '责任人名称',
                prop: 'ownerName'
            }
            // {
            //     prop: 'projectStatus',
            //     value: '项目状态',
            //     label: '项目状态',
            //     type: 'select',
            //     optionsKey: 'CRM_CUSTOMER_PROJECT_STATUS',
            //     options: []
            // }
        ],
        MultipleConfig: {
            NoInsertFirstConfig: true,
            method: 'post',
            // prefix: 'pms-template',
            advanceCascade: { param: {} },
            tableConfig: [
                {
                    prop: 'opportunityCode',
                    value: '商机编码'
                },

                {
                    prop: 'opportunityName',
                    value: '商机名称'
                },
                {
                    prop: 'projectCode',
                    value: '项目编码'
                }
            ]
        },
        otherMultiple: [{ prop: 'id' }, { prop: 'isLinkOppo' }, { prop: 'companyCode' }, { prop: 'opportunityEntityType' }],
        // searchObj: {
        // key: '',
        // keyword: ''
        // },
        searchType: 'input',
        method: 'post',
        prefix: '/api-lcrm',
        advanceUrl: `/opportunity/info/page`,
        cbParams: ['companyCode', 'id#opportunityId', 'opportunityCode', 'opportunityName', 'projectCode', 'opportunityCustomerName', 'companyName', 'businessCenterName',
            'totalScale', 'businessScale', 'cdExpectBiddingSize', 'saleStage', 'lostStage', 'isSign', 'winningDate', 'warehouseType', 'ownerName',
            'isLinkOppo', 'opportunityEntityType'
        ],
        // isCheck:是否校验客户主体 projectType:报价项目类型 isLinkOppo:是否校验关联商机
        beforeRequest: async (params) => {
            await getDictList();
            params.saleStages = dictData.saleStages;
            params.orderBy = 'winning_date';
            params.orderByType = 'desc';
            return params;
        }
    },
    companyParamsAdvance: {
        label: '分公司',
        prop: 'companyName',
        type: '',
        rule: [
            { required: true, message: '分公司不能为空', trigger: 'blur' }
        ],
        name: '添加分公司',
        value: 'companyName',
        advanceConfig: [
            { 'prop': 'companyNameCn', 'value': '分公司名称' },
            { 'prop': 'companyCode', 'value': '分公司编码' }
        ],
        tableConfig: [
            { 'prop': 'companyCode', 'value': '分公司编码' },
            { 'prop': 'companyNameCn', 'value': '分公司名称' }
        ],
        highlightCurrentRow: true,
        noKeyword: true,
        prefix: '/api-mdm',
        advanceUrl: `/esCompany/popCompany`,
        cbParams: ['companyCode#companyCode', 'companyNameCn#companyName'],
        mustFill: true,
        hideTooltip: true,
        width: 200
    }
};
